import { inject, type ObjectPlugin } from 'vue';
import type { Store } from './store';

const PluginsByApp = new WeakMap();

type Options = {
	onInit: (context: Context) => void;
}

type Context = {
	store: Store,
	options: object,
}

/**
 * Плагин tpa (Third-party access) для pinia
 *
 * Сейчас не используется
 *
 * TODO: Должен реализовывать возмоэности piniaTPAPlugin
 */
export default {
	install: (app, options) => {
		if (!PluginsByApp.has(app)) {
			PluginsByApp.set(app, []);
		}

		const onInits = PluginsByApp.get(app);

		onInits.push(options.onInit);

		app.provide('TopStoreOnInits', onInits);
	},
} satisfies ObjectPlugin<Options>;

/**
 * Применить плагины к store
 */
export const usePlugins = (store: Store, options: object = {}) => {
	const context: Context = {
		store,
		options,
	};

	const onInits: Array<Function> = inject('TopStoreOnInits', []);

	onInits.forEach((onInit) => {
		onInit.call(context);
	});
};
